export default __webpack_public_path__ + "static/media/satellite-dish.58c10bbc.svg";